<template>
  <div class="customer-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t('invoices.attachments') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-if="userType=='super_admin'" slot="item-title" to="/super-admin/dashboard" >{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='supplier'" slot="item-title" to="/supplier/dashboard" >{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='anchor'" slot="item-title" to="/anchor/dashboard" >{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='funder'" slot="item-title" to="/funder/dashboard" >{{ $t('general.home') }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link v-if="userType=='super_admin'" slot="item-title" to="/super-admin/invoices" >{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='supplier'" slot="item-title" to="/supplier/invoices" >{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='anchor'" slot="item-title" to="/anchor/invoices" >{{ $tc('invoices.invoice', 2) }}</router-link>
          <router-link v-else-if="userType=='funder'" slot="item-title" to="/funder/invoices" >{{ $tc('invoices.invoice', 2) }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">{{ $tc('invoices.attachments', 2) }}</router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <div v-if="advanceOption && invoiceStatus=='DRAFT'" class="col-xs-2 mr-4">
          <base-button
            size="large"
            icon="plus"
            color="theme"
            @click="addAttachment"
          >
            {{ $t('invoices.newAttachment') }}
          </base-button>
        </div>
      </div>
    </div>
    <SingleInvoiceRow :fetchData="fetchData" :tableDivId="tableDivId"/>

    <div v-cloak v-show="showEmptyScreen" class="col-xs-1 no-data-info" align="center">
      <astronaut-icon class="mt-5 mb-4"/>
      <div class="row" align="center">
        <label class="col title">{{ $t('invoices.no_attachments') }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{ $t('invoices.list_of_attachments') }}</label>
      </div>
      <div v-if="advanceOption && invoiceStatus=='DRAFT'" class="btn-container" >
        <base-button
          :outline="true"
          color="theme"
          class="mt-3"
          size="large"
          @click="addAttachment"
        >
          {{ $t('invoices.add_new_attactment') }}
        </base-button>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">{{ $t('general.showing') }}: <b>{{ attachments.length }}</b></p>

        <transition name="fade">
          <v-dropdown v-if="selectedAttachments.length" :show-arrow="false">
            <span slot="activator" href="#" class="table-actions-button dropdown-toggle">
              {{ $t('general.actions') }}
            </span>
            <v-dropdown-item v-if="advanceOption && invoiceStatus=='DRAFT'">
              <div class="dropdown-item" @click="removeMultipleAttachments"  >
                <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                {{ $t('general.delete') }}
              </div>
            </v-dropdown-item>
          </v-dropdown>
        </transition>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          id="select-all"
          v-model="selectAllFieldStatus"
          type="checkbox"
          class="custom-control-input"
          @change="selectAllAttachments"
        >
        <label for="select-all" class="custom-control-label selectall">
          <span class="select-all-label">{{ $t('general.select_all') }} </span>
        </label>
      </div>

      <table-component
        ref="table"
        :show-filter="false"
        :data="attachments"
        table-class="table"
      >
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="no-click"
        >
          <template slot-scope="row">
            <div class="custom-control custom-checkbox">
              <input
                :id="row.id"
                v-model="selectField"
                :value="row.id"
                type="checkbox"
                class="custom-control-input"
              >
              <label :for="row.id" class="custom-control-label"/>
            </div>
          </template>
        </table-column>
        <table-column
          :label="$tc('documents.documentType', 1)"
          show="documentType.name"
        />
        <table-column
          :label="$t('documents.document')"
          show="name"
        />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span> {{ $t('customers.action') }} </span>
            <v-dropdown>
              <a slot="activator" href="#"><dot-icon /></a>
              <v-dropdown-item>
                <div class="dropdown-item">
                  <a v-if="row.path" :href="row.path" target="_blank" >
                    <font-awesome-icon icon="eye" class="dropdown-item-icon" />
                    {{ $t('general.view') }}
                  </a>
                </div>
              </v-dropdown-item>
              <v-dropdown-item v-if="advanceOption && invoiceStatus=='DRAFT'">
                <div class="dropdown-item" @click="deleteDocument(row)">
                  <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                  {{ $t('general.delete') }}
                </div>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AstronautIcon from '../../components/icon/AstronautIcon'
import SingleInvoiceRow from './SingleInvoiceRow'
export default {
  components: {
    AstronautIcon,
    SingleInvoiceRow
  },
  data () {
    return {
      advanceOption: true,
      isRequestOngoing: true,
      filtersApplied: false,
      userType: '',
      fetchData: [],
      tableDivId: 'tableDivId',
      invoiceStatus: null
    }
  },
  computed: {
    ...mapGetters('documentType', [
      'attachments',
      'totalAttachments',
      'selectedAttachments'
    ]),
    showEmptyScreen () {
      return !this.totalAttachments  && !this.isRequestOngoing
    },
    selectField: {
      get: function () {
        return this.selectedAttachments
      },
      set: function (val) {
        this.selectAttachment(val)
      }
    },
    selectAllFieldStatus: {
      get: function () {
        return this.selectAllField
      },
      set: function (val) {
        this.setSelectAllState(val)
      }
    }
  },
  created () {
    if (localStorage.getItem('role') === 'super_admin' || localStorage.getItem('account_type') === 'anchor' || localStorage.getItem('account_type') === 'funder') {
      this.advanceOption = false
    } else {
      this.advanceOption = true
    }
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
    } else if (localStorage.getItem('account_type') === 'funder') {
      this.userType = 'funder'
    }
    this.loadInvoice()
    this.Attachments()
  },
  methods: {
    ...mapActions('invoice', [
      'fetchInvoice',
      'SingleInvoiceArray'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('documentType', [
      'deleteAttachment',
      'fetchAttachments',
      'selectAllAttachments',
      'setSelectAllState',
      'selectAttachment',
      'deleteMultipleAttachments'
    ]),
    async loadInvoice () {
      let response = await this.SingleInvoiceArray(this.$route.params.id)
      if (response.data) {
        this.fetchData = response.data.invoice
        this.invoiceStatus = response.data.invoice[0].status
      }
    },
    async addAttachment () {
      this.openModal({
        'title': 'Add Attachment',
        'componentName': 'InvoiceAttachmentModal'
      })
    },
    async Attachments () {
      const data = {invoice_id: this.$route.params.id}
      let response = await this.fetchAttachments(data)
      this.isRequestOngoing = false
      return response.data
    },
    async deleteDocument (row) {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('invoices.confirm_attachment_delete'),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
          let data = {
            'attachment_id': row.id,
            'invoice_id': this.$route.params.id
          }
          let res = await this.deleteAttachment(data)
          if (res.data.result === 'success') {
            window.toastr['success'](this.$tc('invoices.deleteAttachment_message'))
            this.Attachments()
          } else if (res.data.error) {
            window.toastr['error'](res.data.message)
          }
        }
      })
    },
    async removeMultipleAttachments () {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('invoices.confirm_attachment_delete', 2),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
          let data = {
            'attachment_ids': this.selectedAttachments,
            'invoice_id': this.$route.params.id
          }
          let request = await this.deleteMultipleAttachments(data)
          if (request.data.result === 'success') {
            window.toastr['success'](this.$tc('invoices.deleteAttachment_message', 2))
            this.Attachments()
          } else if (request.data.error) {
            window.toastr['error'](request.data.message)
          }
        }
      })
    }
  }
}
</script>
<style scoped>
#tableDivId{
  min-height: 0px;
}
</style>
